export default __webpack_public_path__ + "static/media/arrow_down.32f241f4.svg";